// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"8ae249ca","88":"a0dc618d","331":"987d4875","557":"61c9eebe","787":"79c60bb6","831":"9730c4f2","859":"248c832b","869":"e7d366c4","895":"972d5f62"}[chunkId] + ".chunk.js";
};